import validator from "validator";
import message from "../../../messages/ticket";

const validateName = (name) => {
  if (validator.isEmpty(name)) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  if (!name.trim().length) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validateMobile = (mobile) => {
  if (validator.isEmpty(mobile)) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(mobile)) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  if (!mobile.trim().length) {
    return message.ADD_CATEGORY_TICKET_TITLE_DOSE_NOT_EXIST;
  }

  return true;
};

const validateFormNotificationTicket = (data) => {
  const resValidateName = validateName(data.name);
  if (resValidateName != true) {
    return resValidateName;
  }

  const resValidateMobile = validateMobile(data.mobile);
  if (resValidateMobile != true) {
    return resValidateMobile;
  }

  return true;
};

export default validateFormNotificationTicket;
